import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { APIService } from 'src/app/api/api.service';
import { NotifierService } from 'src/app/_services/notifier.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'sg-create-job-element',
  templateUrl: './createjob.component.html',
  styleUrls: ['./createjob.component.css'],
})
export class SGComplianceCreateJobComponent implements OnInit {
  @Output() hideModal = new EventEmitter<boolean>();
  userId = localStorage.getItem("eId");
  uid = localStorage.getItem('t');
  t = localStorage.getItem('t');
  ut = localStorage.getItem('ut');
  eId = localStorage.getItem('eId');
  accountId: any;
  regionId: any;
  urlPrefix: any = localStorage.getItem('role') == 'Admin' ? 'admin' : 'client';
  writeAccess: boolean =
    localStorage.getItem('acT') == 'readandwrite' ||
    this.urlPrefix == 'admin' ||
    localStorage.getItem('ut') == 'admin';
  currentMessage: any;
  resourceGroup: string = localStorage.getItem('selectedResourceGroup');
  selectedCloudPartner: string = null;
  constructor(
    private notifier: NotifierService,
    private apiServer: APIService
  ) {}
  ngOnInit(): void {
    this.accountId = localStorage.getItem('accountId');
    this.regionId = localStorage.getItem('regionId');

    this.currentMessage = this.notifier.currentMessage.subscribe((msg) => {
      let d = JSON.parse(msg);
      if (d.value == null || d.source != 'notifier') {
        return;
      }

      this.selectedCloudPartner = localStorage.getItem("cp-selected");
      if (d.key == 'accountId' && this.selectedCloudPartner == 'aws') {
        this.accountId = d.value;
      } else if (d.key == 'regionId') {
        this.regionId = d.value;
      } else if (d.key == "resourceGroup") {
        this.resourceGroup = d.value;
      }
    });
  }

  async yes() {
    await this.createJob();
    return;
  }

  no() {
    this.hideModal.emit(false);
  }

  async createJob() {
    this.notifier.loading(true);

    let data: any = {
      action: 'create_job',
      account_id: this.accountId,
      region_name: this.regionId,
    };
    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/compliance/sg`;

    if(this.selectedCloudPartner == 'azure') {
      apiURL = `${environment.apiURL}/admin/azure/security`;
      data = {
        action: 'create_job',
        // user_id:
        //   this.urlPrefix == "admin" &&
        //   (localStorage.getItem("selectedAccountGroup") ==
        //     "DevelopmentTestGroup" ||
        //     localStorage.getItem("selectedAccountGroup") == "MinfyDevTeam")
        //     ? "rakeshkumar.t@minfytech.com"
        //     : this.userId,
        user_id: localStorage.getItem("selectedClientList"),
        subscription_id: this.accountId,
        resource_group_name: this.resourceGroup,
        module : "nsg_complaince",
      };
    }

    let result = await this.apiServer.postDataPromis(apiURL, data, header);

    if (result.status == '1' || result.s == '1' || result.status_code == 1) {
      this.notifier.alert('Success', '', result.message, 'success', 5000);
      this.hideModal.emit(true);
    } else {
      this.notifier.alert(
        'Error',
        '',
        result.error_message || result.message,
        'error',
        5000
      );
    }
    this.notifier.loading(false);
  }
}
